import { AppRouter } from './router';

export function App() {
  return <AppRouter />;
}
